/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClusterMinimalStateSchema
 */
export interface ClusterMinimalStateSchema {
    /**
     * 
     * @type {string}
     * @memberof ClusterMinimalStateSchema
     */
    state: string;
}

/**
 * Check if a given object implements the ClusterMinimalStateSchema interface.
 */
export function instanceOfClusterMinimalStateSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "state" in value;

    return isInstance;
}

export function ClusterMinimalStateSchemaFromJSON(json: any): ClusterMinimalStateSchema {
    return ClusterMinimalStateSchemaFromJSONTyped(json, false);
}

export function ClusterMinimalStateSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterMinimalStateSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'state': json['state'],
    };
}

export function ClusterMinimalStateSchemaToJSON(value?: ClusterMinimalStateSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'state': value.state,
    };
}

